module.exports = __webpack_public_path__ + "img/head.ecc19b3d.png";